import { render } from "./entry-stacked.vue?vue&type=template&id=afd7af80&scoped=true"
import script from "./entry-stacked.vue?vue&type=script&lang=js"
export * from "./entry-stacked.vue?vue&type=script&lang=js"

import "./entry-stacked.vue?vue&type=style&index=0&id=afd7af80&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd7af80"]])

export default __exports__